export default __webpack_public_path__ + "static/media/215.7eda484c.png";